// pages/Academics.js
import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";

const Academics = () => {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-orange-50 py-5 px-8">
      <div className="about-header text-center gap-1 mb-6 bg-primary" style={{ backgroundColor: '#F57A25' }}>
        <h1 className="text-2xl sm:text-3xl font-bold text-center " style={{ color: '#F57A25' }}>
          Academics
        </h1>
        <p className="text-center text-base sm:text-lg mb-1 text-white">
          Our academic structure aims to provide a joyful and meaningful learning
          experience that nurtures curiosity, creativity, and confidence.

        </p>
        <p className="text-center text-base sm:text-lg mb-1 text-white">
          Each level of schooling has been designed with care to meet the needs of
          every learner.
        </p>
      </div>

      {/* School Programs - Image Left, Content Right */}
      <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
        <div className="flex flex-column lg:flex-row">
          {/* Image Side */}
          <div className="lg:col-6 relative">
            <img
              src="/images/dis (6).jpg"
              alt="School Programs"
              className="w-full h-full object-cover border-round-xl"
              style={{ height: '400px' }}
            />
            <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
              📚 Academic Programs
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:col-6 p-5 flex flex-column justify-content-center">
            <h3 className="text-3xl font-bold mb-3 text-900" style={{ color: '#03438F' }}>Foundational to Secondary Programs</h3>
            <p className="text-lg text-700 mb-4 line-height-3">
              Our school offers comprehensive programs from Nursery to Grade 12,
              developed in alignment with NEP 2020 and NCERT guidelines. Each phase
              supports smooth transition and ensures holistic development.
            </p>
            <div className="grid mb-4">
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🎯</span>
                </div>
                <span className="text-700">NEP 2020 Aligned</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🌟</span>
                </div>
                <span className="text-700">Holistic Development</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🔍</span>
                </div>
                <span className="text-700">Project-Based Learning</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>📈</span>
                </div>
                <span className="text-700">Continuous Assessment</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Code of Conduct - Image Right, Content Left */}
      <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
        <div className="flex flex-column lg:flex-row-reverse">
          {/* Image Side */}
          <div className="lg:col-6 relative">
            <img
              src="/images/dis (11).jpg"
              alt="Code of Conduct"
              className="w-full h-full object-cover border-round-xl"
              style={{ height: '400px' }}
            />
            <div className="absolute top-3 left-3 bg-blue-600 text-white px-3 py-2 border-round-xl font-bold">
              ⚖️ Code of Conduct
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:col-6 p-5 flex flex-column justify-content-center">
            <h3 className="text-3xl font-bold mb-3 text-900" style={{ color: '#F57A25' }}>Student Code of Conduct</h3>
            <p className="text-lg text-700 mb-4 line-height-3">
              The Code of Conduct sets clear expectations for respect, discipline,
              and integrity within the school community. It helps build a safe and
              supportive atmosphere for learning and personal growth.
            </p>
            <div className="grid mb-4">
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>🤝</span>
                </div>
                <span className="text-700">Respect & Integrity</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>🛡️</span>
                </div>
                <span className="text-700">Safe Environment</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>🌍</span>
                </div>
                <span className="text-700">Global Citizenship</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>💪</span>
                </div>
                <span className="text-700">Accountability</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Health & Safety - Image Left, Content Right */}
      <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
        <div className="flex flex-column lg:flex-row">
          {/* Image Side */}
          <div className="lg:col-6 relative">
            <img
              src="/images/dis (12).jpg"
              alt="Health and Safety"
              className="w-full h-full object-cover border-round-xl"
              style={{ height: '400px' }}
            />
            <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
              🏥 Health & Safety
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:col-6 p-5 flex flex-column justify-content-center">
            <h3 className="text-3xl font-bold mb-3 text-900" style={{ color: '#03438F' }}>Health & Safety Management</h3>
            <p className="text-lg text-700 mb-4 line-height-3">
              The school prioritizes student health and safety through strict
              hygiene standards, regular health checkups, and comprehensive
              emergency care facilities available on campus.
            </p>
            <div className="grid mb-4">
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🧼</span>
                </div>
                <span className="text-700">Hygiene Standards</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🏥</span>
                </div>
                <span className="text-700">Health Checkups</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🚨</span>
                </div>
                <span className="text-700">Emergency Drills</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>👨‍⚕️</span>
                </div>
                <span className="text-700">Medical Facilities</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Assessment & Evaluation - Image Right, Content Left */}
      <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
        <div className="flex flex-column lg:flex-row-reverse">
          {/* Image Side */}
          <div className="lg:col-6 relative">
            <img
              src="/images/lab.jpg"
              alt="Assessment"
              className="w-full h-full object-cover border-round-xl"
              style={{ height: '400px' }}
            />
            <div className="absolute top-3 left-3 bg-blue-600 text-white px-3 py-2 border-round-xl font-bold">
              📊 Assessment System
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:col-6 p-5 flex flex-column justify-content-center">
            <h3 className="text-3xl font-bold mb-3 text-900" style={{ color: '#F57A25' }}>Assessment & Evaluation</h3>
            <p className="text-lg text-700 mb-4 line-height-3">
              Our assessment system focuses on both academic progress and overall
              development. Continuous evaluations help track each student's strengths
              and areas of improvement with personalized guidance.
            </p>
            <div className="grid mb-4">
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>📝</span>
                </div>
                <span className="text-700">Continuous Evaluation</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>🎯</span>
                </div>
                <span className="text-700">Personalized Feedback</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>🌱</span>
                </div>
                <span className="text-700">Growth Mindset</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-orange-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#F57A25' }}>📈</span>
                </div>
                <span className="text-700">Progress Tracking</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Syllabus - Image Left, Content Right */}
      <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
        <div className="flex flex-column lg:flex-row">
          {/* Image Side */}
          <div className="lg:col-6 relative">
            <img
              src="/images/classroom.jpg"
              alt="Syllabus"
              className="w-full h-full object-cover border-round-xl"
              style={{ height: '400px' }}
            />
            <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
              📖 Syllabus 2025-26
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:col-6 p-5 flex flex-column justify-content-center">
            <h3 className="text-3xl font-bold mb-3 text-900" style={{ color: '#03438F' }}>Academic Syllabus (2025–26)</h3>
            <p className="text-lg text-700 mb-4 line-height-3">
              The school follows the NCERT syllabus for the 2025–26 academic year,
              ensuring consistency with national standards and quality education
              across all subjects with real-world applications.
            </p>
            <div className="grid mb-4">
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>📚</span>
                </div>
                <span className="text-700">NCERT Curriculum</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🌐</span>
                </div>
                <span className="text-700">National Standards</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🔗</span>
                </div>
                <span className="text-700">Real-World Applications</span>
              </div>
              <div className="col-12 md:col-6 flex align-items-center mb-2">
                <div className="bg-blue-100 p-2 border-round-lg mr-3">
                  <span style={{ color: '#03438F' }}>🎓</span>
                </div>
                <span className="text-700">Conceptual Clarity</span>
              </div>
            </div>
            <div className="flex gap-2">

            </div>
          </div>
        </div>
      </div>

      {/* Commitment Section */}
      <div className="text-center mt-6 mb-4">
        <div className="max-w-4xl mx-auto border-round-2xl p-5 text-white shadow-2" style={{ background: '#03438F' }}>
          <h2 className="text-3xl font-bold mb-4 text-white ">Excellence in Education</h2>
          <p className="text-xl line-height-3 mb-3 opacity-90">
            Our academic programs go beyond textbooks—fostering curiosity, innovation,
            and confidence in every child through meaningful learning experiences.
          </p>
          <p className="text-lg line-height-3 opacity-80">
            We continuously evolve our teaching methods to meet the changing needs of
            learners, ensuring excellence and holistic growth for every student.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Academics;